/**
 * NoopProvider is the default analytics sink when no vendor is configured.
 * Every method is a no-op that returns synchronously so callers never have to
 * branch on whether analytics is enabled.
 *
 * `ready: false` marks the provider as a pre-bootstrap placeholder: the
 * AnalyticsService then buffers events instead of discarding them, and they
 * replay in order when the real provider is swapped in. The terminal
 * "analytics disabled" Noop stays ready:true so events are dropped, not
 * queued forever.
 *
 * @implements {import('../AnalyticsService').AnalyticsProvider}
 */
export class NoopProvider {
  constructor({ ready = true } = {}) {
    this._ready = ready;
  }

  get name() {
    return "noop";
  }

  async init() {
    return this;
  }

  isReady() {
    return this._ready;
  }

  identify() {}

  reset() {}

  track() {}

  setPersonProperties() {}

  registerSuperProperties() {}

  getSessionId() {
    return null;
  }

  getSessionReplayUrl() {
    return null;
  }
}
